export default __webpack_public_path__ + "static/media/icon_rupee.e909c825.svg";